var storage = {};
var isBrowser = typeof window !== 'undefined' && window.localStorage;
var setItem = function (key, value) {
    if (isBrowser) {
        window.localStorage.setItem(key, value);
    }
    else {
        storage[key] = value;
    }
};
var removeItem = function (key) {
    if (isBrowser) {
        window.localStorage.removeItem(key);
    }
    else {
        delete storage[key];
    }
};
var getItem = function (key) {
    if (isBrowser) {
        return window.localStorage.getItem(key);
    }
    else {
        return storage[key];
    }
};
export default { setItem: setItem, removeItem: removeItem, getItem: getItem };
//# sourceMappingURL=localStorage.js.map